import { IFile } from '@subflow-frontend/@types/file';
import { useMerchant } from '@subflow/data-access';

export const useGenerateLinkToFile = () => {
  const { data: merchant } = useMerchant();

  const generateLink = (file: Pick<IFile, 'id' | 'merchantId'>) => {
    const host = window && window.location.origin;
    const link =
      host + `/sub/${merchant.subDomain}/content/preview/?contentId=${file.id}`;
    return link;
  };

  return {
    generateLink,
  };
};
